// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__E8x3s","input":"CheckBox_input__2JqWZ","hide":"CheckBox_hide__3w1jM"};